import BaseService from "@/module_dashboard/api/base";
import retry from "@/utils/retry";

class DiscoverService extends BaseService {
    constructor(props) {
        super(props);
        this.baseUrl = this.options.baseUrl + '/tenant-discover';
    }

    /**
     * @return Object with results, totalPages, and totalCount.
     * */
    async discover(params) {
        const url = this.baseUrl + '/discover';
        const requestPromise = this.post(url, params);
        return this.httpRequest(requestPromise);
    }

    /**
     * @return A Document with id, type, name, content.
     * */
    async categories() {
        const url = this.baseUrl + '/categories';
        const requestPromise = this.post(url);
        return this.httpRequest(requestPromise);
    }

    async details() {
        const url = this.baseUrl + '/details';
        const requestPromise = this.get(url);
        return this.httpRequest(requestPromise);
    }

    async find(body) {
        const lang = localStorage.getItem('lang') || 'en'
        const url = this.baseUrl + `/find?lang=${lang}`;
        const requestPromise = this.post(url, body);
        return this.httpRequest(requestPromise);
    }
    async findCreators(body) {
        const url = this.baseUrl + '/find/creators';
        const requestPromise = this.post(url, body);
        return this.httpRequest(requestPromise);
    }
}

const getAccessToken = () => localStorage.getItem('token');
export const discoverService = new DiscoverService({
    authToken: getAccessToken,
    refreshToken: retry,
    other: "",
    baseUrl: process.env.VUE_APP_API_URL
});